import { cloneDeep } from "lodash";
import { atom, selector } from "recoil";
import { authState, permissionState } from "../api/state/AuthState";
import Login from "../app/guest/Login";
import ForgotPassword from "../app/guest/ForgotPassword";
import ChangePassword from "../app/guest/ChangePassword";
import Home from "../app/auth/Home";
import Users from "../app/auth/users"
import Roles from "../app/auth/roles"
import Permissions from "../app/auth/permissions"
import NonAuthLayout from "../components/NonAuthLayout";
import TransferBags from "../app/auth/transferBags"
import MailingLists from "../app/auth/mailingLists"
import Bags from "../app/auth/bags"
import BagStatuses from "../app/auth/bagStatuses"
import CaseFiles from "../app/auth/caseFiles"
import Actions from "../app/auth/actions"
import Addresses from "../app/auth/addresses"
import ForwardTypes from "../app/auth/forwardTypes"
import DamageBagClaims from "../app/auth/damageBagClaims"
import ClaimTypes from "../app/auth/claimTypes"
import AddressCategories from "../app/auth/addressCategories"
import AddressTransferTypes from "../app/auth/addressTransferTypes"

import CasesReport from "../app/auth/casesReport"
import TransferBagsReport from "../app/auth/transferBagReport"
import FlightSummary from "../app/auth/flightSummary"



// import HorizontalLayout from "../components/HorizontalLayout";
// import GuestHome from "../app/guest/Home";


const navigation = [
    {
        name: 'Login',
        icon: 'bx bx-lock',
        link: '/login',
        defaultRoute: true,
        component: Login,
        layout: NonAuthLayout,
        middleware: 'guest',
        hidden: true,
        children: [],
    },
    {
        name: 'Forgot Password',
        icon: 'bx bx-lock',
        link: '/forgot-password',
        component: ForgotPassword,
        layout: NonAuthLayout,
        middleware: 'guest',
        hidden: true,
        children: [],
    },
    {
        name: 'Change Password',
        icon: 'bx bx-lock',
        link: '/change-password',
        component: ChangePassword,
        layout: NonAuthLayout,
        middleware: 'guest',
        hidden: true,
        children: [],
    },
    {
        name: 'Dashboard',
        icon: 'mdi mdi-monitor-dashboard',
        link: '/home',
        defaultRoute: true,
        component: Home,
        middleware: 'auth',
        children: [],
    },
	
    {
        name: 'Main',
        icon: "bx bx-group",
        children: [
            { // CaseFile Route Begin
                name: 'Case File',
                icon: 'mdi mdi-file',
                link: '/caseFiles',
                component: CaseFiles,
                middleware: 'auth',
                permission: 'read-caseFiles',
                children: [],
            }, // CaseFile Route End
            { // Bag Route Begin
                name: 'Bag',
                icon: 'mdi mdi-bag-suitcase',
                link: '/bags',
                component: Bags,
                middleware: 'auth',
                permission: 'read-bags',
                children: [],
            }, // Bag Route End
            { // TransferBag Route Begin
                name: 'Transfer Bag',
                icon: 'mdi mdi-airplane-takeoff',
                link: '/transferBags',
                component: TransferBags,
                middleware: 'auth',
                permission: 'read-transferBags',
                children: [],
            }, // TransferBag Route End
            { // Address Route Begin
                name: 'Address',
                icon: 'mdi mdi-home',
                link: '/addresses',
                component: Addresses,
                middleware: 'auth',
                permission: 'read-addresses',
                children: [],
            }, // Address Route End
        ]
    },
    {
        name: 'Master',
        icon: 'bx bx-group',
        children: [
            {
                name: 'Case Master',
                icon: 'mdi mdi-file-cabinet',
                children: [
                    { // ClaimType Route Begin
                        name: 'Claim Type',
                        icon: 'mdi mdi-monitor-dashboard',
                        link: '/claimTypes',
                        component: ClaimTypes,
                        middleware: 'auth',
                        permission: 'read-claimTypes',
                        children: [],
                    }, // ClaimType Route End
                    { // DamageBagClaim Route Begin
                        name: 'Damage Bag Claim',
                        icon: 'mdi mdi-monitor-dashboard',
                        link: '/damageBagClaims',
                        component: DamageBagClaims,
                        middleware: 'auth',
                        permission: 'read-damageBagClaims',
                        children: [],
                    }, // DamageBagClaim Route End
                    { // ForwardType Route Begin
                        name: 'Forward Type',
                        icon: 'mdi mdi-monitor-dashboard',
                        link: '/forwardTypes',
                        component: ForwardTypes,
                        middleware: 'auth',
                        permission: 'read-forwardTypes',
                        children: [],
                    }, // ForwardType Route End
                    { // Action Route Begin
                        name: 'Action',
                        icon: 'mdi mdi-monitor-dashboard',
                        link: '/actions',
                        component: Actions,
                        middleware: 'auth',
                        permission: 'read-actions',
                        children: [],
                    }, // Action Route End
                    { // BagStatus Route Begin
                        name: 'Bag Status',
                        icon: 'mdi mdi-monitor-dashboard',
                        link: '/bagStatuses',
                        component: BagStatuses,
                        middleware: 'auth',
                        permission: 'read-bagStatuses',
                        children: [],
                    }, // BagStatus Route End
                ]
            },
            {
                name: 'Address Master',
                icon: 'mdi mdi-folder-home-outline',
                children: [
                    { // AddressTransferType Route Begin
                        name: 'Address Transfer Type',
                        icon: 'mdi mdi-monitor-dashboard',
                        link: '/addressTransferTypes',
                        component: AddressTransferTypes,
                        middleware: 'auth',
                        permission: 'read-addressTransferTypes',
                        children: [],
                    }, // AddressTransferType Route End
                    { // AddressCategory Route Begin
                        name: 'Address Category',
                        icon: 'mdi mdi-monitor-dashboard',
                        link: '/addressCategories',
                        component: AddressCategories,
                        middleware: 'auth',
                        permission: 'read-addressCategories',
                        children: [],
                    }, // AddressCategory Route End
                ]
            },
            { // MailingList Route Begin
                name: 'Mailing List',
                icon: 'mdi mdi-email-multiple',
                link: '/mailingLists',
                component: MailingLists,
                middleware: 'auth',
                permission: 'read-mailingLists',
                children: [],
            }, // MailingList Route End
        ]
    },
    {
        name: 'Reports',
        icon: "bx bx-group",
        children: [
            {
                name: 'Case Report',
                icon: 'mdi mdi-file-chart-outline',
                link: '/reports/cases',
                component: CasesReport,
                middleware: 'auth',
                permission: 'report-caseFiles',
                children: []
            },
            {
                name: 'Transfer Bags Report',
                icon: 'mdi mdi-file-chart-outline',
                link: '/reports/transferBags',
                component: TransferBagsReport,
                middleware: 'auth',
                permission: 'report-transferBags',
                children: []
            },
            {
                name: 'Flight Summary',
                icon: 'mdi mdi-airplane',
                link: '/reports/flightSummary',
                component: FlightSummary,
                middleware: 'auth',
                permission: 'report-flightSummary',
                children: []
            },
        ]
    },
	// Navigations
    {
        name: 'ACL',
        icon: "bx bx-group",
        children: [
            {
                name: 'Users',
                icon: 'bx bx-group',
                link: '/acl/users',
                component: Users,
                middleware: 'auth',
                permission: 'read-users',
                children: []
            },
            {
                name: 'Roles',
                icon: 'mdi mdi-account-key-outline',
                link: '/acl/roles',
                component: Roles,
                middleware: 'auth',
                permission: 'read-roles',
                children: []
            },
            {
                name: 'Permissions',
                icon: 'bx bx-lock-open-alt',
                link: '/acl/permissions',
                component: Permissions,
                middleware: 'auth',
                permission: 'read-permissions',
                children: []
            },
        ]
    },
];


const megaMenu = [
    // {
    //     name: 'UI Components',
    //     size: 4,
    //     children: [
    //         {
    //             name: 'Lightbox',
    //             link: '/lightbox',
    //             component: GuestHome,
    //             middleware: 'guest',
    //         },
    //         {
    //             name: 'Range Slider',
    //             link: '/rangeslider',
    //             component: GuestHome,
    //             middleware: 'guest',
    //         },
    //     ]
    // },
    // {
    //     name: 'Applications',
    //     size: 4,
    //     children: [
    //         {
    //             name: 'Ecommerce',
    //             link: '/ecommerce',
    //             component: GuestHome,
    //             middleware: 'guest',
    //         },
    //         {
    //             name: 'Calendar',
    //             link: '/calendar',
    //             component: GuestHome,
    //             middleware: 'guest',
    //         },
    //     ]
    // },
    // {
    //     name: 'Extra Pages',
    //     size: 4,
    //     children: [
    //         {
    //             name: 'Maintenance',
    //             link: '/maintenance',
    //             component: GuestHome,
    //             middleware: 'guest',
    //         },
    //         {
    //             name: 'Coming Soon',
    //             link: '/comingsoon',
    //             component: GuestHome,
    //             middleware: 'guest',
    //         },
    //     ]
    // }
]

const rawNavigationState = atom({
    key: 'rawNavigationState',
    default: navigation,
});


const rawMegaMenuState = atom({
    key: 'rawMegaMenuState',
    default: megaMenu,
});





export const navigationState = selector({
    key: 'navigationState',
    get: ({ get }) => {
        let tempNavigation = cloneDeep(get(rawNavigationState))
        const isAuth = get(authState)
        const permissions = get(permissionState)
        const parseModule = (nav) => {
            let returnVal = null
            if(nav.children.length > 0){
                if((isAuth && nav.middleware === "auth" && (!nav.permission || permissions.includes(nav.permission))) || (!isAuth && (nav.middleware === "guest" )) || !nav.middleware){
                    let tempChildren = []
                    nav.children.forEach((child)=>{
                        let temp = parseModule(child)
                        if(temp){
                            tempChildren = [...tempChildren, temp]
                        }
                    })
                    returnVal = {...nav, children: tempChildren}
                }
            } else {
                if((isAuth && nav.middleware === "auth" && (!nav.permission || permissions.includes(nav.permission))) || (!isAuth && (nav.middleware === "guest")) || !nav.middleware){
                    returnVal = nav
                }
            }
            return returnVal
        }
        // Remove Nav Items based on auth and permissions
        tempNavigation = tempNavigation.map((header)=>parseModule(header)).filter(n=>n!==null);
        // Remove Empty Parents
        const filterChildren = (nav) => {
            if(nav.children.filter(c=>c.children.length > 0).length > 0){
                nav.children = nav.children.map((child)=>{
                    child = filterChildren(child)
                    return child
                })
            } else {
                nav.children = nav.children.filter(c=>(c.children.length > 0 || c.component))
            }
            return nav
        }
        tempNavigation = tempNavigation.map((header)=>filterChildren(header));
        // Remove Empty Modules
        tempNavigation = tempNavigation.filter(header=>(header.children.length > 0 || header.component))
        return tempNavigation;
    }
})

export const megaMenuState = selector({
    key: 'megaMenuState',
    get: ({ get }) => {
        let tempMegaMenu = cloneDeep(get(rawMegaMenuState))
        const isAuth = get(authState)
        const permissions = get(permissionState)
        tempMegaMenu = tempMegaMenu.map((header)=>{
            header.children = header.children.filter(c=>(isAuth && c.middleware === "auth" && (!c.permission || permissions.includes(c.permission))) || (!isAuth && (c.middleware === "guest")) || !c.middleware)
            return header
        }).filter(header=>header.children.length > 0);
        return tempMegaMenu;
    }
})
